export const DEFAULT_MIN_ZOOM = 0.1;
export const NOMINAL_ZOOM = 1;
export const MAX_ZOOM = 2;
